import BaseAvailabilityType from './BaseAvailabilityType';

export class AvailabilityAvailable extends BaseAvailabilityType {}
AvailabilityAvailable.defaultProps = {
    text: "A",
    name: "Available",
    availClass: "available",
    altTitle: "Available for online reservation."
};

export class AvailabilityAvailableNumber extends BaseAvailabilityType {}
AvailabilityAvailableNumber.defaultProps = {
    text: "#",
    name: "Available",
    availClass: "available",
    altTitle: "Available for online reservation."
};

export class AvailabilityCheckout extends BaseAvailabilityType {}
AvailabilityCheckout.defaultProps = {
    text: "A",
    name: "Checkout",
    availClass: "available-checkout",
    altTitle: "Available for checking out"
};

export class AvailabilityNotYetReleased extends BaseAvailabilityType {}
AvailabilityNotYetReleased.defaultProps = {
    text: " ",
    name: "Not Yet Released",
    availClass: "not-yet-released",
    altTitle: "Not yet released day"
};

export class AvailabilityWalkUp extends BaseAvailabilityType {}
AvailabilityWalkUp.defaultProps = {
    text: "W",
    name: "Walk-up",
    availClass: "walk-up",
    altTitle: "Available only from the facility's office."
};

export class AvailabilityLottery extends BaseAvailabilityType {}
AvailabilityLottery.defaultProps = {
    text: "L",
    name: "Lottery",
    availClass: "lottery",
    altTitle: "Allocated through lottery, see important dates for information."
};

export class AvailabilityUnavailable extends BaseAvailabilityType {}
AvailabilityUnavailable.defaultProps = {
    text: "#",
    name: "Unavailable",
    availClass: "unavailable",
    altTitle: "Unavailable"
};

export class AvailabilityUnavailableReserved extends BaseAvailabilityType {}
AvailabilityUnavailableReserved.defaultProps = {
    text: "R",
    name: "Reserved",
    availClass: "unavailable",
    altTitle: "Reserved"
};

export class AvailabilityUnavailableCross extends BaseAvailabilityType {}
AvailabilityUnavailableCross.defaultProps = {
    text: "X",
    name: "Unavailable",
    availClass: "unavailable",
    altTitle: "Unavailable"
};

export class AvailabilityUnavailableBlank extends BaseAvailabilityType {}
AvailabilityUnavailableBlank.defaultProps = {
    text: " ",
    name: "Unavailable",
    availClass: "unavailable",
    altTitle: "Unavailable"
};

export class AvailabilityBridged extends BaseAvailabilityType {}
AvailabilityBridged.defaultProps = {
    text: " ",
    name: "Not Yet Released",
    availClass: "available-bridged",
    altTitle: "Reservable only when bridged from an available start date"
};

export class AvailabilitySlidingWindow extends BaseAvailabilityType {}
AvailabilitySlidingWindow.defaultProps = {
    text: " ",
    name: "Sliding Window",
    availClass: "available-bridged",
    altTitle: "Reservable only when bridged from an available start date"
};

export class AvailabilityFirstComeFirstServed extends BaseAvailabilityType {}
AvailabilityFirstComeFirstServed.defaultProps = {
    text: "FF",
    name: "First-come, First-served",
    availClass: "first-come",
    altTitle: "Available only from a first come, first served basis."
};
